import React from 'react'
import PropTypes from 'prop-types'
import theme from '../../theme'
import { Box } from '@mui/material'

// material components
import Typography from '@mui/material/Typography'


const styles = {
    root: {
        // height: 154,
        marginRight: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        //boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
        [theme.breakpoints.down('xs')]: {
            width: 210,
            height: 'auto',
            marginRight: 0,
            marginBottom: theme.spacing.unit * 3,
        },
        [theme.breakpoints.down("sm")]: {
            width: 210,
            height: 'auto',
            marginRight: 0,
            marginBottom: theme.spacing.unit * 3,
        },
    },
    clickAble: {
        '&:hover': {
            cursor: 'pointer',
        },
    },
    label: {
        padding: 10,
        color: theme.palette.secondary.dark,
        backgroundColor: '#fff',
        boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.2)',
        borderTopLeftRadius:10,
        borderTopRightRadius:10

    },
    content: {
        padding: '14px 8px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '4px 4px 10px 0 rgba(0, 0, 0, 0.2)',
        borderBottomLeftRadius:10,
        borderBottomRightRadius:10,
        [theme.breakpoints.down('xs')]: {
            padding: 5,
        },
    },
    icon: {
        width: '40%',
        display: 'flex',
        alignItems: 'flex-end',
    },
    text: {
        width: '60%',
        height: 100,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'space-between',
        paddingTop: 2,
        [theme.breakpoints.down('xs')]: {
            height: 108,
        },
    },
}

/**
 * component for main element
 * @param classes
 * @param active
 * @param label
 * @param icon
 * @param children
 * @param handleCardState
 * @param color
 * @param notClickAble
 * @returns {*}
 * @constructor
 */

/*  <div role="note" className={[classes.root, classes[(!notClickAble) ? 'clickAble' : null]].join(' ')} onClick={e => handleCardState(id, scope)}  style={{borderRadius:'20px!important'}}> */
const Card = ({ classes, active, label, icon, children, handleCardState, color, notClickAble, id, scope }) => (
    <Box role="note" width={245} maxWidth={"90%"} style={{...styles.root}} sx={!notClickAble?styles.clickAble:null} onClick={e => handleCardState(id, scope)} >
        <div style={styles.label}>
            <Typography style={{fontSize: 20}} variant="h5" color={theme.typography.cardLabel}>{('' !== label.trim() ? label : 'Neues Gerät')}</Typography>
        </div>
        <div style={{ ...styles.content, backgroundColor: ((active) ? '#949494' : color )}}>
            <div style={styles.icon}>
                 {icon}
            </div>
            <div style={styles.text}>
                {children}
            </div>
        </div>
    </Box>
)

Card.defaultProps = {
    notClickAble: false,
}

Card.propTypes = {
    active: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([PropTypes.object, PropTypes.symbol]).isRequired,
    children: PropTypes.node.isRequired,
    handleCardState: PropTypes.func.isRequired,
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    color: PropTypes.string.isRequired,
    notClickAble: PropTypes.bool,
}

export default Card
